import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import "./TableStyle.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PaginationBar from "./PaginationBar";
import TimeFormatter from "../newTimeformatter/TimeFormatter";
import SyncIcon from "@mui/icons-material/Sync";
import { Modal, Spinner } from "react-bootstrap";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import Hexapi from "../HexAPI/Hexapi";
import Select from "../Selectlist/select";
import Swal from "sweetalert2";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "@mui/material/Pagination";
import Othercategory from "../../othercategory/Additionlisttypedata";
import { Category } from "@mui/icons-material";
import Additionlisttypedata from "../../othercategory/Additionlisttypedata";
import axios from "axios";
import ImportFile from "../Excel/ImportFile";
import ExportFile from "../Excel/ExportFile";

var oldData = [];

export default class ProductDatatable extends Component {
  constructor() {
    super();
    this.audioRef = React.createRef();
    this.state = {
      rowData: [],
      isDataFound: false,
      currentPaginationPage: 0,
      showPaginationRows: 0,
      isShowSearchBox: false,
      searchValue: "",
      showaudio: false,
      Status: false,
      oldData: "",
      rowuserid: "",
      joinus: "",
      origin: "",
      origindata: [],
      joindata: [],
      OpenAddScreen: false,
      windowwidth: window.innerWidth,
      name: "",
      sku: "",
      description: "",
      Weight: "",
      Length: "",
      Width: "",
      Height: "",
      mrp: "",
      WholesalePrice: "",
      OverseasPrice: "",
      Category: "",
      Subcategory: "",
      Images: null,
      SuitableForModel: "",
      SuitableForSubModel: "",
      SuitableForPartReference: "",
      CompanyCode: "",
      WarehouseLocation: "",
      RackSection: "",
      RackCode: "",
      PouchTubeCode: "",
      BoxCode: "",
      HSNCode: 0,
      GST: 0,
      Make: "",
      ProductCondition: "",
      Brand: "",
      CountryOfOrigin: "",
      ConversionRate: 0,
      MOQ: 0,
      VisibilityDomestic: 0,
      VisibilityOverseas: 0,
      ProductId: -1,
      screen: "",
      Totalpages: 0,
      CurrentPage: 1,
      Categorydata: [],
      subcategorydata: [],
      SuitableForModeldata: [],
      SuitableForSubModeldata: [],
      CompanyCodedata: [],
      WarehouseLocationdata: [],
      RackSectiondata: [],
      RackCodedata: [],
      PouchTubeCodedata: [],
      BoxCodedata: [],
      HSNCodedata: [],
      GSTdata: [],
      Makedata: [],
      ProductConditiondata: [],
      Branddata: [],
      CountryOfOrigindata: [],
      ConversionRatedata: [],
      MOQdata: [],
      SuitableForPartReferencedata: [],
      ColumnData: [],
      Columnname: "",
      ImageArr: [],
      showimage: false,
      currentimage: null,
      fieldErrors: {},
      fetchRsUrl: `${sessionStorage.getItem("Apipathurl")}fetchrsdataV2.php`,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.handlechangeinput = this.handlechangeinput.bind(this);
  }

  handleshowimage = (image) => {
    this.setState({ showimage: true, currentimage: image });
  };

  componentDidMount() {
    this.setState({ ColumnData: this.props.ColumnNames });
    let obj1 = {
      query: `[dbo].[Seetech_Web_Proc_ProductMaster_FormGetDatav2]`,
      queryArr: [],
    };
    Hexapi(obj1).then((res) => {
      this.setState({
        Categorydata: res.category,
        subcategorydata: res.subcategory,
        SuitableForModeldata: res.suitableformodel,
        SuitableForSubModeldata: res.suitableforsubmodel,
        CompanyCodedata: res.companycode,
        WarehouseLocationdata: res.warehouselocation,
        RackSectiondata: res.racksection,
        RackCodedata: res.rackcode,
        PouchTubeCodedata: res["pouch/tubecode"],
        BoxCodedata: res.boxcode,
        HSNCodedata: res.hsncode,
        GSTdata: res.gst,
        Makedata: res.make,
        ProductConditiondata: res.productcondition,
        Branddata: res.brand,
        CountryOfOrigindata: res.countryoforigin,
        ConversionRatedata: res.conversionrate,
        MOQdata: res.moq,
      });
    });
    const updatedData = this.props.data.map((item) => ({
      Delete: item.Delete,
      Edit: item.Edit,
      ...item,
    }));

    oldData = updatedData;
    this.setState({ rowData: updatedData, isDataFound: true });
    this.props.pagination &&
      this.setState({ showPaginationRows: this.props.pagination.rowsPerPage });
    let obj = {
      query: `[dbo].[Seetech_Web_Proc_ProductMaster_GetData] @UserID='{0}',@Search='{1}',@Page='{2}'`,
      queryArr: [`6`, `-1`, "1"],
    };
    Hexapi(obj).then((res) => {
      const pages = Math.ceil(res["totalcount"][0].totalcount / 20);
      if (res["totalcount"][0].totalcount < 20) {
        this.setState({ Totalpages: 1 });
      } else {
        this.setState({ Totalpages: pages });
      }
    });

    window.addEventListener("resize", this.handleWindowSize);
  }

  reloadTable() {
    console.log("reload");
  }

  handlecategorychange = (e) => {
    this.setState({ Columnname: e.target.value });
  };

  handleWindowSize = () => {
    this.setState({ windowwidth: window.innerWidth });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSize);
  }

  getHeader(data) {
    const header = Object.keys(data[0]);
    return header.map((s) => {
      if (s === "registeredcontactnumber") {
        return <th key={s}>Registered Contact Number</th>;
      }
      return <th key={s}>{s}</th>;
    });
  }

  clearSearch(e) {
    this.setState({
      rowData: oldData,
      isDataFound: true,
      isShowSearchBox: false,
      searchValue: "",
    });
  }

  setDate(date) {
    if (date !== undefined) {
      var transformdate = date.split(".")[0];
      var exitdate = TimeFormatter(transformdate);
      var newReverseDate =
        exitdate.ShiftTime +
        "," +
        exitdate.userSplitedDate[2] +
        "-" +
        exitdate.ShiftMonth +
        "-" +
        exitdate.CurYear.toString().slice(-2);
      return newReverseDate;
    }
  }

  handleDelete(index) {
    const updatedImages = [...this.state.ImageArr];
    updatedImages.splice(index, 1);
    this.setState({
      ImageArr: updatedImages,
      Images: updatedImages.join(","),
    });
  }

  handlechangeinput = async (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const dataimage = e.target.files[0];

    // Check if CompanyCode is selected (as it acts as PartNo for syncing)
    if (!this.state.CompanyCode) {
      Swal.fire({
        icon: "warning",
        title: "Company Code Required",
        text: "Please select or enter the Company Code (PartNo) before uploading an image.",
      });
      e.target.value = "";
      return;
    }

    try {
      const formdata = new FormData();
      formdata.append("file", dataimage);

      // Determine whether this is the first image before modifying the array
      const isFirstImage = this.state.ImageArr.length === 0;

      // Step 1: Upload file to server
      const imagedata = await axios.post(
        `${sessionStorage.getItem("Apipathurl")}ImageUpload.php`,
        formdata,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      const uploadedUrl = imagedata.data;
      const updatedArr = [...this.state.ImageArr, uploadedUrl];
      const updatedimage = updatedArr.join(",");

      this.setState((prevState) => ({
        ImageArr: updatedArr,
        Images: updatedimage,
        fieldErrors: { ...prevState.fieldErrors, Images: undefined },
      }));

      // Step 2: Trigger Backend Synchronization ONLY for the 1st Image
      if (isFirstImage) {
        const syncResponse = await axios.post(
          `${sessionStorage.getItem("Apipathurl")}ImageSync.php`,
          {
            PartNo: this.state.CompanyCode,
            URL: uploadedUrl,
          },
        );

        if (syncResponse.data && syncResponse.data.command === 1) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "First Image Uploaded & Synced Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Sync Status",
            text:
              syncResponse.data.message ||
              "Image uploaded, but sync skipped/failed.",
          });
        }
      } else {
        // Just notify success for subsequent uploads without triggering ImageSync.php
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Image Uploaded Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (err) {
      console.error("Image upload error:", err);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "There was an error uploading the image.",
      });
    } finally {
      // Clear file input so the user can re-upload if needed
      e.target.value = "";
    }
  };

  getProductFieldErrors = () => {
    const errors = {};
    const required = [
      "sku",
      "name",
      "description",
      "Weight",
      "Length",
      "Width",
      "Height",
      "mrp",
      "WholesalePrice",
      "OverseasPrice",
      "Category",
      "Subcategory",
      "Images",
      "SuitableForModel",
      "SuitableForSubModel",
      "SuitableForPartReference",
      "CompanyCode",
      "WarehouseLocation",
      "RackCode",
      "RackSection",
      "PouchTubeCode",
      "BoxCode",
      "HSNCode",
      "GST",
      "Make",
      "ProductCondition",
      "Brand",
      "CountryOfOrigin",
      "ConversionRate",
      "MOQ",
    ];

    required.forEach((field) => {
      const value = this.state[field];
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        value === 0
      ) {
        errors[field] = true;
      }
    });

    return errors;
  };

  getFieldErrorStyle = (field) => {
    return this.state.fieldErrors && this.state.fieldErrors[field]
      ? { border: "2px solid red", borderRadius: "4px" }
      : {};
  };

  onProductInputChange = (field, value) => {
    const updatedErrors = { ...this.state.fieldErrors };
    if (updatedErrors[field]) {
      delete updatedErrors[field];
    }
    this.setState({ [field]: value, fieldErrors: updatedErrors });
  };

  EditProductData = () => {
    const fieldErrors = this.getProductFieldErrors();
    if (Object.keys(fieldErrors).length === 0) {
      let obj = {
        query: ` [dbo].[Seetech_Web_Proc_ProductMaster_Edit]
                        @ProductID='{0}',
                         @SKU='{1}',
                         @Name='{2}',
                         @Description='{3}',
                         @Weight='{4}',
                         @Length='{5}',
                         @Width='{6}',
                         @Height='{7}',
                         @MRP='{8}',
                         @WholesalePrice='{9}',
                         @OverseasPrice='{10}',
                         @Category='{11}',
                         @Subcategory='{12}',
                         @Images='{13}',
                         @SuitableForModel='{14}',
                         @SuitableForSubModel='{15}',
                         @SuitableForPartReference='{16}',
                         @CompanyCode='{17}',
                         @WarehouseLocation='{18}',
                         @RackSection='{19}',
                         @RackCode='{20}',
                         @PouchTubeCode='{21}',
                         @BoxCode='{22}',
                         @HSNCode='{23}',
                         @GST='{24}',
                         @Make='{25}',
                         @ProductCondition='{26}',
                         @Brand='{27}',
                         @CountryOfOrigin='{28}',
                         @ConversionRate='{29}',
                         @MOQ='{30}',
                         @VisibilityDomestic='{31}',
                         @VisibilityOverseas='{32}'`,
        queryArr: [
          `${this.state.ProductId}`,
          `${this.state.sku}`,
          `${this.state.name}`,
          `${this.state.description}`,
          `${this.state.Weight}`,
          `${this.state.Length}`,
          `${this.state.Width}`,
          `${this.state.Height}`,
          `${this.state.mrp}`,
          `${this.state.WholesalePrice}`,
          `${this.state.OverseasPrice}`,
          `${this.state.Category}`,
          `${this.state.Subcategory}`,
          `${this.state.Images}`,
          `${this.state.SuitableForModel}`,
          `${this.state.SuitableForSubModel}`,
          `${this.state.SuitableForPartReference}`,
          `${this.state.CompanyCode}`,
          `${this.state.WarehouseLocation}`,
          `${this.state.RackCode}`,
          `${this.state.RackSection}`,
          `${this.state.PouchTubeCode}`,
          `${this.state.BoxCode}`,
          `${this.state.HSNCode}`,
          `${this.state.GST}`,
          `${this.state.Make}`,
          `${this.state.ProductCondition}`,
          `${this.state.Brand}`,
          `${this.state.CountryOfOrigin}`,
          `${this.state.ConversionRate}`,
          `${this.state.MOQ}`,
          `${this.state.VisibilityDomestic}`,
          `${this.state.VisibilityOverseas}`,
        ],
      };
      Hexapi(obj).then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: res[""][0]["msg"],
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.props.callback(true);
        });
      });
    } else {
      this.setState({ fieldErrors });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill all required fields.",
      });
    }
  };

  setProduct = (data) => {
    const imagesdata = data.images;
    var mapdata = [];
    if (imagesdata !== "" && imagesdata !== null && imagesdata !== undefined) {
      const newimages = imagesdata.split(",");
      mapdata = newimages
        .map((ele) => {
          if (ele !== "" && ele !== undefined) {
            return ele.replace("/wp-content", "");
          }
          return null;
        })
        .filter(Boolean);
    }
    this.setState({
      ImageArr: mapdata,
      name: data.name,
      sku: data.sku,
      description: data.description,
      Weight: data.width,
      Length: data.length,
      Width: data.weight,
      Height: data.height,
      mrp: data.mrp,
      WholesalePrice: data.wholesaleprice,
      OverseasPrice: data.overseasprice,
      Category: data.category,
      Subcategory: data.subcategory,
      Images: mapdata.join(","),
      SuitableForModel: data.suitableformodel,
      SuitableForSubModel: data.suitableforsubmodel,
      SuitableForPartReference: data.suitableforpartreference,
      CompanyCode: data.companycode,
      WarehouseLocation: data.warehouselocation,
      RackSection: data.racksection,
      RackCode: data.rackcode,
      PouchTubeCode: data["pouch/tubecode"],
      BoxCode: data.boxcode,
      HSNCode: data.hsncode,
      GST: data.gst,
      Make: data.make,
      ProductCondition: data.productcondition,
      Brand: data.brand,
      CountryOfOrigin: data.countryoforigin,
      ConversionRate: data.conversionrate,
      MOQ: data.moq,
      VisibilityDomestic: data.visibilitydomestic,
      VisibilityOverseas: data.visibilityoverseas,
      ProductId: data.recid,
      fieldErrors: {},
      OpenAddScreen: true,
    });
  };

  DeleteProduct = (Id) => {
    Swal.fire({
      text: "Are you sure to Delete Product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        container: "custom-swal-container",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          query: `[dbo].[Seetech_Web_Proc_ProductMaster_Delete] @UserID='{0}',@ProductID='{1}'`,
          queryArr: [`${sessionStorage.getItem("userid")}`, `${Id}`],
        };
        Hexapi(obj).then((res) => {
          this.props.callback(true);
        });
      }
    });
  };

  getRowsData(data) {
    var newTableData = [].concat(data);
    let newData = newTableData;
    if (this.props.pagination) {
      newData = newTableData.filter((row, index) => {
        let rowPerPage =
          this.state.showPaginationRows < 0
            ? newTableData.length
            : this.state.showPaginationRows;
        let start = this.state.currentPaginationPage * rowPerPage;
        let end = (this.state.currentPaginationPage + 1) * rowPerPage;
        if (index >= start && index < end) return true;
        return false;
      });
    }
    return newData.map((row, i) => {
      return (
        <tr
          key={`row-` + i}
          onClick={() => {
            this.props.onRowClick(row);
          }}
        >
          {Object.keys(row).map((heading) => {
            if (row[heading] == null) {
              row[heading] = "";
            }

            if (
              typeof row[heading] !== "object" &&
              heading !== "status" &&
              heading !== "Edit" &&
              heading !== "Delete"
            ) {
              return (
                <td
                  key={heading}
                  dangerouslySetInnerHTML={{ __html: row[heading] }}
                />
              );
            } else if (heading === "Edit") {
              return (
                <td key={heading}>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setProduct(row);
                      this.setState({ screen: "edit" });
                    }}
                  >
                    <EditIcon style={{ color: "rgb(66 137 165)" }} />
                  </span>
                </td>
              );
            } else if (heading === "Delete") {
              return (
                <td key={heading}>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      this.DeleteProduct(row.recid);
                    }}
                  >
                    <DeleteIcon style={{ color: "red" }} />
                  </span>
                </td>
              );
            } else if (heading === "status") {
              if (row["status"] == 0) {
                return (
                  <td key={heading}>
                    <span
                      onClick={() => {
                        this.setState({
                          membership: true,
                          rowuserid: row["userid"],
                        });
                      }}
                    >
                      <DoneIcon />
                    </span>
                    <span
                      onClick={() => {
                        this.Rejectrequest(row["userid"]);
                      }}
                    >
                      <CloseIcon />
                    </span>
                  </td>
                );
              } else if (row["status"] == 1) {
                return <td key={heading}>Approved</td>;
              } else {
                return <td key={heading}>Rejected</td>;
              }
            } else {
              return (
                <td
                  key={heading}
                  dangerouslySetInnerHTML={{
                    __html: this.setDate(row[heading].date),
                  }}
                />
              );
            }
          })}
        </tr>
      );
    });
  }

  AddProduct = () => {
    const fieldErrors = this.getProductFieldErrors();
    if (Object.keys(fieldErrors).length === 0) {
      let obj = {
        query: ` [dbo].[Seetech_Web_Proc_ProductMaster_Add]
                             @SKU='{0}',
                             @Name='{1}',
                             @Description='{2}',
                             @Weight='{3}',
                             @Length='{4}',
                             @Width='{5}',
                             @Height='{6}',
                             @MRP='{7}',
                             @WholesalePrice='{8}',
                             @OverseasPrice='{9}',
                             @Category='{10}',
                             @Subcategory='{11}',
                             @Images='{12}',
                             @SuitableForModel='{13}',
                             @SuitableForSubModel='{14}',
                             @SuitableForPartReference='{15}',
                             @CompanyCode='{16}',
                             @WarehouseLocation='{17}',
                             @RackSection='{18}',
                             @RackCode='{19}',
                             @PouchTubeCode='{20}',
                             @BoxCode='{21}',
                             @HSNCode='{22}',
                             @GST='{23}',
                             @Make='{24}',
                             @ProductCondition='{25}',
                             @Brand='{26}',
                             @CountryOfOrigin='{27}',
                             @ConversionRate='{28}',
                             @MOQ='{29}',
                             @VisibilityDomestic='{30}',
                             @VisibilityOverseas='{31}'`,
        queryArr: [
          `${this.state.sku}`,
          `${this.state.name}`,
          `${this.state.description}`,
          `${this.state.Weight}`,
          `${this.state.Length}`,
          `${this.state.Width}`,
          `${this.state.Height}`,
          `${this.state.mrp}`,
          `${this.state.WholesalePrice}`,
          `${this.state.OverseasPrice}`,
          `${this.state.Category}`,
          `${this.state.Subcategory}`,
          `${this.state.Images}`,
          `${this.state.SuitableForModel}`,
          `${this.state.SuitableForSubModel}`,
          `${this.state.SuitableForPartReference}`,
          `${this.state.CompanyCode}`,
          `${this.state.WarehouseLocation}`,
          `${this.state.RackSection}`,
          `${this.state.RackCode}`,
          `${this.state.PouchTubeCode}`,
          `${this.state.BoxCode}`,
          `${this.state.HSNCode}`,
          `${this.state.GST}`,
          `${this.state.Make}`,
          `${this.state.ProductCondition}`,
          `${this.state.Brand}`,
          `${this.state.CountryOfOrigin}`,
          `${this.state.ConversionRate}`,
          `${this.state.MOQ}`,
          `${this.state.VisibilityDomestic}`,
          `${this.state.VisibilityOverseas}`,
        ],
      };
      Hexapi(obj).then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: res[""][0]["msg"],
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.props.callback(true);
        });
      });
    } else {
      this.setState({ fieldErrors });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill all required fields.",
      });
    }
  };

  storeSearch(e) {
    if (this.state.Columnname !== "") {
      let obj = {
        query: `[dbo].[Seetech_Web_Proc_ProductMaster_searchdata] @Column='{0}',@SearchValue='{1}'`,
        queryArr: [`${this.state.Columnname}`, `${e}`],
      };
      Hexapi(obj).then((res) => {
        if (res[""].length > 0) {
          const updatedData = res[""].map((item) => ({
            Delete: item.Delete,
            Edit: item.Edit,
            ...item,
          }));
          this.setState({ rowData: updatedData });
        } else {
          this.setState({ isDataFound: false });
        }
      });
    } else {
      let obj = {
        query: `[dbo].[Seetech_Web_Proc_ProductMaster_GetData] @UserID='{0}',@Search='{1}',@Page='{2}'`,
        queryArr: [`6`, `${this.state.searchValue}`, "1"],
      };
      Hexapi(obj).then((res) => {
        const updatedData = res[""].map((item) => ({
          Delete: item.Delete,
          Edit: item.Edit,
          ...item,
        }));
        this.setState({ rowData: updatedData });
      });
    }
  }

  Addform = () => {
    this.setState({
      name: "",
      sku: "",
      description: "",
      Weight: "",
      Length: "",
      Width: "",
      Height: "",
      mrp: "",
      WholesalePrice: "",
      OverseasPrice: "",
      Category: "",
      Subcategory: "",
      Images: "",
      ImageArr: [],
      SuitableForModel: "",
      SuitableForSubModel: "",
      SuitableForPartReference: "",
      CompanyCode: "",
      WarehouseLocation: "",
      RackSection: "",
      RackCode: "",
      PouchTubeCode: "",
      BoxCode: "",
      HSNCode: 0,
      GST: 0,
      Make: "",
      ProductCondition: "",
      Brand: "",
      CountryOfOrigin: "",
      ConversionRate: 0,
      MOQ: 0,
      VisibilityDomestic: "",
      VisibilityOverseas: "",
      ProductId: -1,
      fieldErrors: {},
      OpenAddScreen: true,
      screen: "add",
    });
  };

  fetchPage = (event, value) => {
    this.setState({ CurrentPage: value, isDataFound: false });
    let obj = {
      query: `[dbo].[Seetech_Web_Proc_ProductMaster_GetData] @UserID='{0}',@Search='{1}',@Page='{2}'`,
      queryArr: [`6`, `-1`, ` ${value}`],
    };
    Hexapi(obj).then((res) => {
      const updatedData = res[""].map((item) => ({
        Delete: item.Delete,
        Edit: item.Edit,
        ...item,
      }));
      this.setState({ rowData: updatedData, isDataFound: true });
    });
  };

  render() {
    return (
      <>
        <div style={{ height: "calc(78vh - 5px)" }}>
          <div style={{ position: "relative", height: "inherit" }}>
            {this.props.isNavbar && (
              <div className="_tablenavbar2">
                <div className="_left">
                  <span>{this.props.heading}</span>
                  <span
                    className="Add1"
                    style={{
                      padding: "5px",
                      fontSize: "0.9rem",
                      background: "rgb(208, 132, 12)",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      this.Addform();
                    }}
                  >
                    Add +
                  </span>
                </div>
                <div className="_right">
                  <Tooltip title="Refresh">
                    <IconButton
                      style={{ color: "#fff" }}
                      onClick={() => {
                        this.setState({ isDataFound: false });
                        this.props.callback(true);
                      }}
                    >
                      <SyncIcon />
                    </IconButton>
                  </Tooltip>
                  <select
                    onChange={this.handlecategorychange}
                    style={{
                      height: "30px",
                      marginRight: "10px",
                      borderRadius: "6px",
                    }}
                    value={this.state.Columnname}
                  >
                    <option value="">---Select----</option>
                    {this.state.ColumnData.map((s, index) => {
                      return (
                        <option value={s} key={`Column` + index}>
                          {s}
                        </option>
                      );
                    })}
                  </select>

                  <input
                    type="text"
                    id="searchBarFocus"
                    autoFocus={true}
                    value={this.state.searchValue}
                    style={{
                      width: "250px",
                      padding: this.state.isShowSearchBox
                        ? "6px 12px"
                        : "6px 0px",
                      marginLeft: this.state.isShowSearchBox ? "10px" : "0px",
                    }}
                    className="editable"
                    placeholder="Search..."
                    onChange={(e) =>
                      this.setState({ searchValue: e.target.value })
                    }
                  />
                  {this.state.isShowSearchBox ? (
                    <Tooltip title="Close Search">
                      <IconButton
                        style={{ color: "#fff" }}
                        onClick={() => this.clearSearch()}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  <Tooltip title="Open Search">
                    <IconButton
                      style={{ color: "#fff" }}
                      onClick={() =>
                        this.setState({ isShowSearchBox: true }, () => {
                          this.storeSearch(this.state.searchValue);
                        })
                      }
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>
                  <span
                    className="Add2"
                    style={{
                      padding: "5px",
                      fontSize: "0.9rem",
                      background: "rgb(208, 132, 12)",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      this.Addform();
                    }}
                  >
                    Add +
                  </span>
                </div>
              </div>
            )}
            <Table
              id="_tableGrid"
              className={"table-hover table2"}
              responsive
              style={{ width: "300%" }}
            >
              <thead style={this.props.headStyle}>
                <tr>
                  {this.state.isDataFound &&
                    this.state.rowData.length > 0 &&
                    this.getHeader(this.state.rowData)}
                </tr>
              </thead>
              {this.state.isDataFound ? (
                this.state.rowData.length > 0 ? (
                  <tbody>{this.getRowsData(this.state.rowData)}</tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="100%">
                        <h3>No Data Found!</h3>
                      </td>
                    </tr>
                  </tbody>
                )
              ) : (
                <tbody>
                  <tr>
                    <td
                      colSpan="100%"
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Spinner
                        animation="border"
                        style={{ color: "#f9b101" }}
                      />
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Pagination
                count={this.state.Totalpages}
                page={this.state.CurrentPage}
                onChange={(event, page) => this.fetchPage(event, page)}
              />
            </div>
          </div>
        </div>

        <Modal
          id="documentmodal"
          centered
          animation={true}
          show={this.state.OpenBulkUploadModal}
          onHide={() => this.setState({ OpenBulkUploadModal: false })}
          style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
        >
          <Modal.Header closeButton>
            <Modal.Title> {"Bulk Upload"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="importbox">
              <ImportFile
                name={"Import"}
                fetchRsUrl={this.state.fetchRsUrl}
                reloadTable={this.reloadTable.bind(this)}
                query={`[dbo].[CRM_Proc_Import_Leads_Submit] @AgentID='${this.state.agentid}', @Json='{0}'`}
              />
            </div>
            <div className="exportbox">
              <ExportFile
                name={"Template"}
                fetchRsUrl={this.state.fetchRsUrl}
                query={`[dbo].[CRM_Proc_Import_Leads_Template_getData] @AgentID='${this.state.agentid}'`}
                downloadUrl={this.state.excelDownloadUrl}
              />
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          id="documentmodal"
          fullscreen
          centered
          animation={true}
          show={this.state.OpenAddScreen}
          onHide={() => this.setState({ OpenAddScreen: false })}
          style={{ backgroundColor: "rgba(0, 0, 0, 0.9)" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.screen === "edit" ? "Edit Product" : "Add Product"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row" style={{ width: "95%", margin: "auto" }}>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>SKU</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("sku"),
                    }}
                    value={this.state.sku}
                    onChange={(e) => {
                      this.onProductInputChange("sku", e.target.value);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Name</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("name"),
                    }}
                    value={this.state.name}
                    onChange={(e) => {
                      this.onProductInputChange("name", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Description</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <textarea
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      maxHeight: "80px",
                      minHeight: "80px",
                      ...this.getFieldErrorStyle("description"),
                    }}
                    value={this.state.description}
                    onChange={(e) => {
                      this.onProductInputChange("description", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Weight </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("Weight"),
                    }}
                    value={this.state.Weight}
                    onChange={(e) => {
                      this.onProductInputChange("Weight", e.target.value);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Length </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("Length"),
                    }}
                    value={this.state.Length}
                    onChange={(e) => {
                      this.onProductInputChange("Length", e.target.value);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Width </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("Width"),
                    }}
                    value={this.state.Width}
                    onChange={(e) => {
                      this.onProductInputChange("Width", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Height </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("Height"),
                    }}
                    value={this.state.Height}
                    onChange={(e) => {
                      this.onProductInputChange("Height", e.target.value);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>MRP </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("mrp"),
                    }}
                    value={this.state.mrp}
                    onChange={(e) => {
                      this.onProductInputChange("mrp", e.target.value);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>WholesalePrice </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("WholesalePrice"),
                    }}
                    value={this.state.WholesalePrice}
                    onChange={(e) => {
                      this.onProductInputChange(
                        "WholesalePrice",
                        e.target.value,
                      );
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>OverseasPrice </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    step="any"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("OverseasPrice"),
                    }}
                    value={this.state.OverseasPrice}
                    onChange={(e) => {
                      this.onProductInputChange(
                        "OverseasPrice",
                        e.target.value,
                      );
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Category</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("Category")}
                    listdata={this.state.Categorydata}
                    itemdata={this.state.Category}
                    setdata={(data) => {
                      this.onProductInputChange("Category", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Subcategory</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("Subcategory")}
                    listdata={this.state.subcategorydata}
                    itemdata={this.state.Subcategory}
                    setdata={(data) => {
                      this.onProductInputChange("Subcategory", data);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>CompanyCode (PartNo) </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("CompanyCode")}
                    listdata={this.state.CompanyCodedata}
                    itemdata={this.state.CompanyCode}
                    setdata={(data) => {
                      this.onProductInputChange("CompanyCode", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Images </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="file"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("Images"),
                    }}
                    onChange={this.handlechangeinput}
                  />
                  <div className="d-flex">
                    {this.state.ImageArr.map((ele, ind) => {
                      return (
                        <div
                          key={`img-${ind}`}
                          className="disdata"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={ele}
                            className="img-sec img-fluid"
                            alt="preview"
                            onClick={() => this.handleshowimage(ele)}
                            onError={(e) => {
                              e.target.src =
                                "https://seetechparts.com/uploads/2023/11/dummy.png";
                            }}
                          />
                          <span
                            className="disclose"
                            onClick={() => this.handleDelete(ind)}
                          >
                            <RxCross2 />
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {this.state.showimage && (
                <Modal
                  show={this.state.showimage}
                  onHide={() => this.setState({ showimage: false })}
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}
                >
                  <Modal.Header closeButton></Modal.Header>
                  <Modal.Body>
                    <img
                      src={this.state.currentimage}
                      className="img-fluid"
                      alt="enlarged preview"
                      onError={(e) => {
                        e.target.src =
                          "https://seetechparts.com/uploads/2023/11/dummy.png";
                      }}
                    />
                  </Modal.Body>
                </Modal>
              )}

              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>SuitableForModel</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("SuitableForModel")}
                    listdata={this.state.SuitableForModeldata}
                    itemdata={this.state.SuitableForModel}
                    setdata={(data) => {
                      this.onProductInputChange("SuitableForModel", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>SuitableForSubModel </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("SuitableForSubModel")}
                    listdata={this.state.SuitableForSubModeldata}
                    itemdata={this.state.SuitableForSubModel}
                    setdata={(data) => {
                      this.onProductInputChange("SuitableForSubModel", data);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>SuitableForPartReference </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("SuitableForPartReference"),
                    }}
                    value={this.state.SuitableForPartReference}
                    onChange={(e) => {
                      this.onProductInputChange(
                        "SuitableForPartReference",
                        e.target.value,
                      );
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>WarehouseLocation </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("WarehouseLocation")}
                    listdata={this.state.WarehouseLocationdata}
                    itemdata={this.state.WarehouseLocation}
                    setdata={(data) => {
                      this.onProductInputChange("WarehouseLocation", data);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>RackSection </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("RackSection")}
                    listdata={this.state.RackSectiondata}
                    itemdata={this.state.RackSection}
                    setdata={(data) => {
                      this.onProductInputChange("RackSection", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>RackCode</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("RackCode")}
                    listdata={this.state.RackCodedata}
                    itemdata={this.state.RackCode}
                    setdata={(data) => {
                      this.onProductInputChange("RackCode", data);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>PouchTubeCode</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("PouchTubeCode")}
                    listdata={this.state.PouchTubeCodedata}
                    itemdata={this.state.PouchTubeCode}
                    setdata={(data) => {
                      this.onProductInputChange("PouchTubeCode", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>BoxCode </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("BoxCode")}
                    listdata={this.state.BoxCodedata}
                    itemdata={this.state.BoxCode}
                    setdata={(data) => {
                      this.onProductInputChange("BoxCode", data);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>HSNCode </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("HSNCode")}
                    listdata={this.state.HSNCodedata}
                    itemdata={this.state.HSNCode}
                    setdata={(data) => {
                      this.onProductInputChange("HSNCode", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>GST </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("GST")}
                    listdata={this.state.GSTdata}
                    itemdata={this.state.GST}
                    setdata={(data) => {
                      this.onProductInputChange("GST", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Make </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("Make")}
                    listdata={this.state.Makedata}
                    itemdata={this.state.Make}
                    setdata={(data) => {
                      this.onProductInputChange("Make", data);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>ProductCondition </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("ProductCondition")}
                    listdata={this.state.ProductConditiondata}
                    itemdata={this.state.ProductCondition}
                    setdata={(data) => {
                      this.onProductInputChange("ProductCondition", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>Brand </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("Brand")}
                    listdata={this.state.Branddata}
                    itemdata={this.state.Brand}
                    setdata={(data) => {
                      this.onProductInputChange("Brand", data);
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>CountryOfOrigin </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <Additionlisttypedata
                    style={this.getFieldErrorStyle("CountryOfOrigin")}
                    listdata={this.state.CountryOfOrigindata}
                    itemdata={this.state.CountryOfOrigin}
                    setdata={(data) => {
                      this.onProductInputChange("CountryOfOrigin", data);
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>ConversionRate</b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("ConversionRate"),
                    }}
                    value={this.state.ConversionRate}
                    onChange={(e) => {
                      this.onProductInputChange(
                        "ConversionRate",
                        e.target.value,
                      );
                    }}
                    onClick={() => {
                      this.onProductInputChange("ConversionRate", "");
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>MOQ </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="number"
                    className="signupinput"
                    style={{
                      marginTop: "5px",
                      height: "40px",
                      ...this.getFieldErrorStyle("MOQ"),
                    }}
                    value={this.state.MOQ}
                    onChange={(e) => {
                      this.onProductInputChange("MOQ", e.target.value);
                    }}
                    onClick={() => {
                      this.onProductInputChange("MOQ", "");
                    }}
                  />
                </div>
              </div>
              <div className="Fieldstyle">
                <div style={{ width: "100%" }}>
                  <label>
                    <b>VisibilityDomestic </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="checkbox"
                    style={{ marginLeft: "10px" }}
                    checked={this.state.VisibilityDomestic ? true : false}
                    onChange={(e) => {
                      this.setState({
                        VisibilityDomestic: e.target.checked ? 1 : 0,
                      });
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <label>
                    <b>VisibilityOverseas </b>
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    type="checkbox"
                    checked={this.state.VisibilityOverseas ? true : false}
                    style={{ marginLeft: "10px" }}
                    onChange={(e) => {
                      this.setState({
                        VisibilityOverseas: e.target.checked ? 1 : 0,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row" id="Submitbtn" style={{ marginTop: "20px" }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {this.state.screen === "add" ? (
                  <button
                    style={{
                      color: "white",
                      margin: "8px 0px",
                      padding: "10px 30px",
                      backgroundColor: "black",
                      borderRadius: "10px",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      this.AddProduct();
                    }}
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    style={{
                      color: "white",
                      margin: "8px 0px",
                      padding: "10px 30px",
                      backgroundColor: "black",
                      borderRadius: "10px",
                    }}
                    onClick={() => {
                      this.EditProductData();
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
